import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=3b88a91a&scoped=true&"
import script from "./JobForm.vue?vue&type=script&lang=js&"
export * from "./JobForm.vue?vue&type=script&lang=js&"
import style0 from "./JobForm.vue?vue&type=style&index=0&id=3b88a91a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88a91a",
  null
  
)

export default component.exports